import * as React from 'react';

import Stub from 'shared/newComponents/Stub';
import Typography from 'shared/newComponents/Typography';
import {
  TypographyColor,
  TypographySize,
  TypographyType,
  TypographyWeight
} from 'shared/newEntities/components/Typography';
import { TranslationString } from 'shared/entities/localization';

import './EmptyContent.modules.scss';

type Props = {
  text: TranslationString;
  withStub?: boolean;
};

const EmptyContent: React.FC<Props> = ({ text, withStub }) => {
  if (withStub) {
    return (
      <div styleName="empty-content_stub">
        <Stub title={text} size={TypographySize.s} withIcon />
      </div>
    );
  }

  return (
    <div className="flex-horizontal-align" styleName="empty-content">
      <Typography
        fontType={TypographyType.text}
        fontSize={TypographySize.s}
        fontColor={TypographyColor.secondary}
        fontWeight={TypographyWeight.heavy}
      >
        {text}
      </Typography>
    </div>
  );
};

export default React.memo(EmptyContent);
